import React from 'react';
import { useLocation } from 'react-router-dom';

export const useGetUrlParams = () => {
  const location = useLocation();
  const paramsFromUrl = new URLSearchParams(location?.search);
  return { paramsFromUrl, location };
};
